import React, { Component } from 'react';
import PageSpinner from 'components/Spinner/PageSpinner';
import Header from 'components/Header/Header';
// Intentionally no API imports; this page is UI-only for now
import Style from 'pages/addPodcast/addPodcastStyles.module.css';
import InputBox from 'components/InputBox/InputBox';
import Button from 'components/Button/Button';
import { logEventPagesViewed } from 'utils/analytics';

class AddPodcastPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      user: null,
      rssURL: '',
      activeTab: 0,
      loading: true,
      loadingText: '',
      loadingAnimation: null,
      successMessage: '',
      errorMessage: '',
    };
  }

  async componentDidMount() {
    // Track page view (non-blocking)
    logEventPagesViewed(null, window.location.href, 'add_podcast_page', 'Add Podcast').catch(err => {
    });
    
    window.scrollTo({ top: 0, behavior: 'smooth' });
    document.addEventListener('keydown', this.onKeyDown);
    await this.fetchUser();
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown);
  }

  fetchUser = async () => {
    // Skip network calls; leave page usable as UI-only
    this.setState({ loading: false });
  };

  onKeyDown = (e) => {
    if (!e.key) {
      return;
    }
    if (e.key === 'SoftRight' || e.key === 'ArrowLeft') {
      this.props.history.push('/settings');
    } else if (e.key === 'ArrowDown') {
      this.setState((prevState) => ({
        activeTab: prevState.activeTab < 1 ? prevState.activeTab + 1 : prevState.activeTab,
      }));
    } else if (e.key === 'ArrowUp') {
      this.setState((prevState) => ({
        activeTab: prevState.activeTab > 0 ? prevState.activeTab - 1 : prevState.activeTab,
      }));
    } else if (e.key === 'Enter') {
      this.submitPodcastHandler();
    } else if (e.key === 'Backspace') {
      if (this.state.activeTab !== 0) {
        this.props.history.goBack();
      }
    }
  };

  backHandler = () => {
    this.props.history.push('/settings');
  };

  rssURLChangeHandler = (event) => {
    this.setState({
      successMessage: '',
      errorMessage: '',
      activeTab: 0,
      rssURL: event.target.value,
    });
    if (!event.target.value) {
      this.setState({ errorMessage: 'Please enter RSS URL' });
    }
  };

  updateLoadingText = () => {
    this.setState((prevState) => {
      const newText = prevState.loadingText === '...' ? '.' : prevState.loadingText + '.';
      return { loadingText: newText };
    });
  };

  submitPodcastHandler = () => {
    // No API call. Provide gentle feedback and keep UI state
    const { rssURL } = this.state;
    if (!rssURL) {
      this.setState({ errorMessage: 'Please enter RSS URL' });
      return;
    }
    this.setState({ successMessage: 'This feature will be enabled soon.', errorMessage: '', loadingText: '' });
  };

  render() {
    const { user, rssURL, loading, successMessage, errorMessage, activeTab, loadingText } = this.state;
    return (
      <>
        <Header title='Add Podcast' back={true} backHandler={this.backHandler} />
        <div className={Style.headerComponent}>
          {loading ? (
            <PageSpinner />
          ) : (
            <div className={Style.AddPodcastLayout}>
              {successMessage.length ? <span style={{ marginTop: '5px', marginBottom: '5px', color: 'green', fontSize: '0.8rem' }}>{successMessage}</span> : <></>}
              {errorMessage.length ? <span style={{ marginTop: '5px', marginBottom: '5px', color: 'red', fontSize: '0.8rem' }}>{errorMessage}</span> : <></>}
              <span style={{ fontWeight: 'bold' }}>Add RSS URL</span>
              <span className={Style.PodcastInput}>
                <InputBox inputValue={rssURL} inputChangeHandler={this.rssURLChangeHandler} isFocus={activeTab === 0} />
              </span>
              <div className={Style.PodcastButton}>
                <Button buttonText={`Submit Podcast${loadingText}`} buttonOnClick={this.submitPodcastHandler} isFocus={activeTab === 1 || rssURL} disabled={!rssURL || loadingText} />
              </div>
            </div>
          )
          }
        </div>
      </>
    );
  }
}

export default AddPodcastPage;
